import { makeStyles } from '@material-ui/core'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked'

const colorfulColors = {
  0: '#B72224',
  1: '#D52029',
  2: '#E95223',
  3: '#EA6F22',
  4: '#F6A726',
  5: '#FDC729',
  6: '#EBDB0A',
  7: '#E7E145',
  8: '#C2D234',
  9: '#AEC93C',
  10: '#66B44E'
}

const useStyles = makeStyles({
  noMargin: {
    margin: 0
  },
  radioBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'auto',
    marginBottom: '2px',
    padding: '0',
    boxSizing: 'border-box',
    height: '40px',
    userSelect: 'none',
    backgroundColor: '#e1e0e1',
    cursor: 'pointer',
    '& .MuiIconButton-root': {
      display: 'none'
    },
    '& .MuiFormControlLabel-label': {
      color: '#fff',
      fontFamily: "'Helvetica', 'Arial', sans-serif",
      fontWeight: 600,
      fontSize: '16px',
      lineHeight: 1,
      textAlign: 'center'
    }
  }
})

const getFixedColorByIndex = (index, total) => {
  if (!total || total <= 0) return colorfulColors[0]
  if (total === 1) return colorfulColors[0]

  const maxColorIndex = 10
  const mappedColorIndex = Math.round((index * maxColorIndex) / (total - 1))

  return colorfulColors[mappedColorIndex]
}

const SingleSelectColorFull = ({ field, form, formField, index, ...props }) => {
  const classes = useStyles()
  const totalItems = formField?.FormFieldValues?.length || 0
  const color = getFixedColorByIndex(index, totalItems)
  const optionValue = (
    props?.id ??
    formField?.FormFieldValues?.[index]?.IdYourviews ??
    ''
  ).toString()
  const currentValue = (field?.value ?? '').toString()
  const isSelected = currentValue === optionValue
  const gap = 3
  const itemsPerRow = totalItems > 10 ? 10 : totalItems
  const totalGap = itemsPerRow > 1 ? (itemsPerRow - 1) * gap : 0
  const dynamicWidth =
    itemsPerRow > 0 ? `calc((100% - ${totalGap}px) / ${itemsPerRow})` : '100%'
  const isLastItemInRow =
    itemsPerRow > 0 ? (index + 1) % itemsPerRow === 0 : false
  const isLastItem = index === totalItems - 1

  return (
    <FormControlLabel
      label={props.label}
      className={`${classes.noMargin} ${classes.radioBox}`}
      onClick={() => form.setFieldValue(field.name, optionValue)}
      style={{
        backgroundColor: color,
        border: isSelected ? '1px solid #333' : 'none',
        width: dynamicWidth,
        minWidth: dynamicWidth,
        flexBasis: dynamicWidth,
        marginRight: isLastItemInRow || isLastItem ? 0 : `${gap}px`,
        transform: isSelected ? 'scale(1.06)' : 'scale(1)',
        transformOrigin: 'center',
        transition: 'transform 0.15s ease, border 0.15s ease',
        zIndex: isSelected ? 1 : 0
      }}
      labelPlacement={props.valuetype === 0 ? 'end' : 'bottom'}
      control={
        <Radio
          {...field}
          {...props}
          size="small"
          color="primary"
          value={optionValue}
          className={classes.noMargin}
          checked={isSelected}
          onChange={() => form.setFieldValue(field.name, optionValue)}
          data-testid={`${field.name}-${field.id}`}
          checkedIcon={
            <RadioButtonCheckedIcon
              fontSize="small"
              style={{
                margin: 0,
                color: props?.bgcolor || color
              }}
            />
          }
        />
      }
    />
  )
}

export default SingleSelectColorFull
